<template lang="html">
  <div class="commentEnter">
    <div v-if="commentData && commentData.total > 0">
      <div
        class="commentEnterTitle"
        :style="{ 'padding-bottom': commentData.count > 0 ? '0' : '0.24rem' }"
        @click="toMemberEvaluate()"
      >
        <p class="userComment pf-medium">
          用户评价<span class="number">{{ numComment }}</span>
        </p>
        <a href="javascript:;">
          <div class="more">
            <span v-if="toAllComment != '' && commentData.praiseRate >= 95"
              >好评率 {{ commentData.praiseRate }}%</span
            >
            <!-- <i class="moreIcon" /> -->
          </div>
        </a>
      </div>
      <ul class="tagsT" v-if="tagT && tagT.length > 0 && commentData.count > 0">
        <li
          v-for="(item, index) in tagT.slice(0, 3)"
          :key="index"
          @click="chooseItems(item)"
          v-if="item.num > 0"
        >
          <span class="title">{{ item.labelName }}</span>
        </li>
      </ul>
      <div class="commentEnterConetnt" v-if="commentData.count > 0">
        <commentItem
          source="member"
          v-for="(comment, i) in commentData.list.slice(0, 2)"
          :comment="comment"
          :key="comment.id"
          :showReply="false"
          :type="toAllComment"
        ></commentItem>
      </div>
      <div
        class="toAllCommentContent"
        v-if="commentData.count >= 2 && toAllComment != ''"
      >
        <a class="toAllComment" href="javascript:;" @click="toMemberEvaluate()"
          >查看更多</a
        >
      </div>
    </div>
    <div v-else class="emptyComment">暂无评价</div>
  </div>
</template>

<script>
import commentItem from '@/components/newComment/commentItem'
import { pushHref } from '@/plugins/jump'
import { mapState } from 'vuex'
export default {
  inject: {
    allCommentTrackParams: {
      default: null
    }
  },
  data() {
    return {
      tagT: []
    }
  },
  props: {
    commentData: {
      // 评价数据
      type: Object,
      default() {
        return {}
      }
    },
    toAllComment: {
      // 查看更多评价
      type: String,
      default() {
        return ''
      }
    },
    id: {
      type: String | Number,
      default() {
        return ''
      }
    },
    uid: {
      type: String | Number,
      default() {
        return ''
      }
    },
    level4CategoryId: {
      type: String | Number,
      default() {
        return ''
      }
    }
  },
  components: {
    commentItem
  },
  async mounted() {
    if (this.isCzjSpu) {
    } else if (this.id && this.level4CategoryId)
      await this.getCommentLabelList(this.id, this.level4CategoryId)
  },
  computed: {
    ...mapState(['product', 'selectedSku', 'isCzjSpu']),
    numComment() {
      let num = this.commentData.total
      if (num > 9999) {
        num = `${parseFloat(Number(num / 10000).toFixed(1))}万+`
      }
      return num
    },
    isRebuilding() {
      // 产后恢复
      return (
        this.product &&
        this.product.spuId &&
        this.product.level4CategoryId &&
        parseInt(+this.product.level4CategoryId / 100) === 101121
      )
    }
  },
  methods: {
    chooseItems(item) {
      if (this.isRebuilding) {
        //产后恢复
        const skuid = this.selectedSku && this.selectedSku.skuId
        const popid = this.product && this.product.businessId
      }
      this.$$loading(true)
      window.scrollTo(0, 0)
      this.$router.push({
        name: 'comments',
        params: {
          spuId: this.id
        },
        query: {
          level4CategoryId: this.level4CategoryId,
          labelId: item.id
        }
      })
      // location.href = `${this.$$hostname('life')}/v/product/${this.id}/comments?level4CategoryId=${this.level4CategoryId}&labelId=${item.id}`
    },
    async getCommentLabelList(rid, level4CategoryId) {
      const query = {
        category4Id: level4CategoryId,
        rid
      }
      const res = await this.$store.dispatch('getNewCommentLabelList', query)
      if (res.errno == 0 && res.data && res.data.length > 0) {
        this.tagT = res.data
      } else {
        console.log(res.errmsg)
      }
    },
    toMemberEvaluate() {
      this.allCommentTrackParams &&
        this.$$newTrackClick(this.allCommentTrackParams)
      if (this.isCzjSpu) {
        const url = `//m.czj100.com/comment/${this.product.spuId}?type=4&title=${this.product.spuName}`
        location.href = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
          url
        )}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie('skey')}`
      } else {
        if (this.isRebuilding) {
          //产后恢复
          const skuid = this.selectedSku && this.selectedSku.skuId
          const popid = this.product && this.product.businessId
        }
        this.$$loading(true)
        window.scrollTo(0, 0)
        if (this.toAllComment == 'product' && this.level4CategoryId) {
          // 商品详情列表
          this.$router.push({
            name: 'comments',
            params: {
              spuId: this.id
            },
            query: {
              level4CategoryId: this.level4CategoryId
            }
          })
          // location.href = `${this.$$hostname('life')}/v/product/${this.id}/comments?level4CategoryId=${this.level4CategoryId}`
        } else if (this.toAllComment == 'certified') {
          // 认证育儿师 99
          this.$router.push({
            name: 'comment-list',
            params: {
              workerCode: this.id
            },
            query: {
              userType: 99,
              uid: this.uid
            }
          })
          // location.href = `${this.$$hostname('life')}/v/comments/${this.id}?userType=99&uid=${this.uid}`
        } else if (this.toAllComment == 'adviser') {
          // 埋点 --  育儿-育儿顾问 1 页-查看更多评价
          this.$router.push({
            name: 'comment-list',
            params: {
              workerCode: this.id
            },
            query: {
              userType: 1,
              uid: this.uid
            }
          })
          // location.href = `${this.$$hostname('life')}/v/comments/${this.id}?userType=1&uid=${this.uid}`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.commentEnter {
  padding-bottom: rem(2px);
  background-color: #fff;

  .tagsT {
    padding: 0 0 0;
    display: flex;
    flex-wrap: wrap;

    & > li {
      height: rem(52px);
      background: #feecea;
      border-radius: rem(28px);
      padding: rem(8px) rem(24px);
      font-size: rem(24px);
      line-height: rem(36px);
      color: #262626;
      text-align: center;
      margin: rem(18px) rem(14px) 0 0;
      @include border(all, #feecea, 1px, 28px);

      .number {
        margin-left: rem(8px);
      }

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .commentEnterTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // margin-bottom: rem(30px);
    background: #fff;
    // padding-bottom: 0.2rem;

    .userComment {
      // font-weight: 700;
      font-size: rem(32px);
      color: #121212;
      line-height: rem(42px);

      .number {
        font-size: rem(22px);
        color: #262626;
        line-height: rem(30px);
        font-weight: normal;
        margin-left: rem(12px);
      }
    }
    .more {
      min-width: rem(100px);
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: rem(24px);
      color: #ff5900;
      line-height: rem(30px);
    }
    .moreIcon {
      margin-left: rem(10px);
      width: rem(20px);
      height: rem(20px);
      background: url('~@/assets/images/comment/icon-more.png') no-repeat center
        center;
      background-size: 100% 100%;
    }
  }
  .toAllCommentContent {
    padding-bottom: rem(36px);
  }
  .toAllComment {
    display: block;
    height: rem(60px);
    width: rem(208px);
    margin: 0 auto;
    @include border(all, #cccccc, 1px, 30px);
    border-radius: rem(30px);
    font-size: rem(24px);
    color: #262626;
    text-align: center;
    line-height: rem(60px);
  }
  .emptyComment {
    font-weight: 700;
    font-size: rem(34px);
    color: #121212;
    line-height: rem(42px);
    padding-bottom: rem(24px);
  }
}
</style>
